// routes/_app.profile.edit.accounts.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.profile.edit.accounts')

export const handle = {
  name: 'profile/edit/accounts',
  track: { scene: 'profile-edit', section: 'accounts' },
}

export default dynamic(getClientModule, { ssr: false })
